import { Strings } from '@aura/core-lib';
import React, { createContext, useState } from 'react';
import { Matricula, PerfilAluno, useUsuario } from '../usuario';
import { IMatriculaContext, MatriculaProps, MatriculaVO, Provider } from './matricula.types';

export const MatriculaContext = createContext<IMatriculaContext | null>(null);

const converterMatriculaParaMatriculaVO = (matricula: Matricula): MatriculaVO => {
  return {
    id: matricula?.id,
    nome: matricula?.nomeCurso,
    calendario: matricula?.calendario,
    tipoCurso: matricula?.tipoCurso,
    turnoCurso: matricula?.turno,
    campusCurso: matricula?.campus,
    modalidade: matricula?.modalidade,
    matricula: matricula?.matricula,
    periodo: matricula?.periodo,
  };
};

export const MatriculaProvider: Provider = ({ children }: MatriculaProps) => {
  const contextoUsuario = useUsuario();

  const usuario: PerfilAluno = contextoUsuario.get()?.aura?.dados as PerfilAluno;

  if (!usuario) {
    throw new Error('Contexto de usuário é necessário');
  }

  const statusMatriculasPermitidas = ['ATIVO', 'FORMANDO'];

  const [primeiraMatricula] = [
    ...usuario.matriculas.filter((matricula) =>
      statusMatriculasPermitidas.includes(Strings.normalize({ target: matricula.situacao })),
    ),
  ];

  const [matriculaUsuarioSelecionada, setMatriculaUsuarioSelecionado] = useState<MatriculaVO>(() => {
    return converterMatriculaParaMatriculaVO(primeiraMatricula);
  });

  return (
    <MatriculaContext.Provider
      value={{
        primeira: primeiraMatricula,
        selecionadaVO: matriculaUsuarioSelecionada,
        selecionada: usuario.matriculas.find((m) => m.id === matriculaUsuarioSelecionada?.id) ?? primeiraMatricula,
        setSelecionada: (matricula) => {
          setMatriculaUsuarioSelecionado(matricula);
        },
        atualizarPorEntrega: () => {
          setMatriculaUsuarioSelecionado(null);
        },
        remover: () => setMatriculaUsuarioSelecionado(null),
      }}
    >
      {children}
    </MatriculaContext.Provider>
  );
};
